define('lq/events/abortError',['lq/oop'], function (oop) {
    'use strict';

    function AbortError(message) {
        this.name = 'AbortError';
        this.message = message || 'An abort of the current event was requested.';
    }

    AbortError.prototype = new Error();
    
    return AbortError;
});
